import { component } from 'flightjs';
import $ from 'jQuery';
import template from 'underscore/modules/template';
import BankIdVerificationModal from './bank-id-verification-modal';

const bankIdVerification = function() {
    this._timer = 0;
    this.isBankIdCancelled = false;
    this.bankIdAutoStartToken = null;

    this.defaultAttrs({
        showPopup: '[data-account-locked-show-poppup]',
        confirmPasswordModalTemplate: '[data-modal-account-locked-template]',
        bankIdVerifyModal: '[data-modal-account-locked]'
    });

    this.after('initialize', function() {
        let self = this;
        this.on('click', {
            showPopup: self.showBankIdModal
        });
    });

    this.showBankIdModal = function() {
        this.isBankIdCancelled = false;
        let modalHtml = this.getHtmlForModal();
        let payload = {
            content: modalHtml,
            cssClass: 'modal-default-new-style modal-background',
            nonDismissible: true
        };
        this.trigger(document, 'ui:modal:open', payload);
        BankIdVerificationModal.attachTo(this.attr.bankIdVerifyModal);
    };

    this.getHtmlForModal = function(itemId, itemTitle) {
        let html = $(this.attr.confirmPasswordModalTemplate).html();
        let templateFn = template(html);
        return templateFn({ itemId: itemId, itemTitle: itemTitle });
    };
};

export default component(bankIdVerification);
